var exports = {
  "q": "x127c5a35--0f2d31--footer",
  "Q": "x127c5a35--0f2d31--text",
};

module.exports = exports;
